/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import './styles.scss';
import { TabSwitcherProps } from './types';
import { withAnalytics } from '@veneer/analytics';
import { generateID } from '../../base/helper';

const TTabSwitcher: React.FC<TabSwitcherProps> = ({
  id = generateID('clientos-ui-toolkit-tab-switcher'),
  items,
  onChange,
  selected
}) => {
  const baseClass = 'clientos-ui-toolkit-tab-switcher';
  return (
    <div
      className={baseClass}
      id={id}
    >
      <div
        className={`${baseClass}__container`}
        id={`${id}__container`}
      >
        {items.map((item, index) => (
          <div
            role="button"
            key={index}
            className={
              index === selected
                ? `${baseClass}__item-selected ${item.disabled ? 'disabled' : ''}`
                : `${baseClass}__item ${item.disabled ? 'disabled' : ''}`
            }
            id={`${id}__item-${index}`}
            onClick={item.disabled ? undefined : () => onChange(index)}
          >
            {item.icon}
          </div>
        ))}
      </div>
    </div>
  );
};

export const TabSwitcherAnalytics = withAnalytics(TTabSwitcher);
export default TTabSwitcher;
